import fetch from 'cross-fetch';

export const servicesAccessOptions = {
  accessToken: undefined
};

export function fetchEnhanced(service, request, onSuccess, onFail) {
  var serviceLocation = service;
  if (!serviceLocation.startsWith('/')) {
    serviceLocation = '/' + service;
  }

  const requestDescriptor = {
    mode: 'cors',
    credentials: 'include',
    ...request
  };

  if (requestDescriptor.headers === undefined) {
    requestDescriptor.headers = {};
  }

  if (servicesAccessOptions.accessToken !== undefined) {
    requestDescriptor.headers['x-access-token'] = servicesAccessOptions.accessToken;
  }

  if (request.method === 'POST') {
    requestDescriptor.headers['Content-Type'] = 'application/json';
  }

  fetch(`${process.env.REACT_APP_API_URL}` + serviceLocation, requestDescriptor)
    .then((r) => {
      if (r.status === 401 || r.status === 403) {
        // Redirect to account-login page
        let error = new Error('AUTH_REQUIRED');
        error.errorType = 'AUTH_REQUIRED';
        error.status = r.status;
        throw error;
      }

      if (r.status === 500) {
        let error = new Error('SVC_ERROR');
        error.errorType = 'SVC_ERROR';
        error.status = r.status;
        throw error;
      }

      return r;
    })
    .then((r) => r.json().then(data => ({response: r, body: data})).catch((error) => ({response: r, body: undefined})))
    .then((r) => {
      if (onSuccess) {
        onSuccess(r.response, r.body);
      }
    })
    .catch((error) => {
      console.log("An error occurred while accessing: " + serviceLocation); console.log(error);

      if (error.errorType === undefined) {
        error.errorType = 'CONN_FAILED';
      }

      if (onFail) {
        onFail(error.errorType, error.status);
      }
    })
}